import { useEffect } from 'react';
import { onCLS, onFCP, onLCP, onTTFB, onINP } from 'web-vitals';

/**
 * Performance monitoring hook
 * Tracks Web Vitals metrics and logs to console (can be extended to send to analytics)
 */
export const usePerformanceMonitoring = () => {
  useEffect(() => {
    const logMetric = (metric) => {
      console.log('[Web Vitals]', {
        name: metric?.name,
        value: metric?.value,
        rating: metric?.rating,
        delta: metric?.delta,
        id: metric?.id
      });

      // Send to analytics if needed
      if (window?.gtag) {
        window.gtag('event', metric?.name, {
          value: Math.round(metric?.name === 'CLS' ? metric?.value * 1000 : metric?.value),
          event_category: 'Web Vitals',
          event_label: metric?.id,
          non_interaction: true
        });
      }
    };

    // Cumulative Layout Shift
    onCLS(logMetric);
    
    // First Input Delay - removed as deprecated in web-vitals v3+
    // onFID(logMetric);
    
    // First Contentful Paint
    onFCP(logMetric);
    
    // Largest Contentful Paint
    onLCP(logMetric);
    
    // Time to First Byte
    onTTFB(logMetric);
    
    // Interaction to Next Paint
    onINP(logMetric);
  }, []);
};

export default usePerformanceMonitoring;
